import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.tasks,
    (tasks) => {
        return {
            tasks
        }
    }
)